import useLocalStorage from 'hooks/useLocalStorage/useLocalStorage';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getWebsiteMetaTitle, updateBrand } from 'redux/brand';
import { useAppDispatch } from 'redux/store';
import { useGetWeborderingConfigurationQuery } from 'services/brand/brand.endpoints';
import { makeTheme } from 'utils/style';

export const useAppVM = () => {
    const queryBrandHash = new URLSearchParams(window.location.search).get('brandHash');
    const { value, setInLocalStorage } = useLocalStorage<string>('brandHash');
    const dispatch = useAppDispatch();
    const title = useSelector(getWebsiteMetaTitle);

    const brandHash = queryBrandHash ?? value;

    const {
        data: weborderingConfiguration,
        isError,
        isLoading,
        error,
    } = useGetWeborderingConfigurationQuery({
        brandHash: brandHash ?? 'no-brand',
    });

    useEffect(() => {
        if (weborderingConfiguration && brandHash && brandHash !== value) {
            setInLocalStorage(brandHash);
        }
    }, [setInLocalStorage, value, weborderingConfiguration, brandHash]);

    useEffect(() => {
        dispatch(updateBrand(weborderingConfiguration || null));
    }, [dispatch, weborderingConfiguration]);

    const apiTheme = weborderingConfiguration?.module_style_styles.find(
        ({ is_enabled }) => is_enabled,
    );

    const { theme, themeCss } = makeTheme(apiTheme);

    return { title, theme, themeCss, error, isError, isLoading };
};
